import script from './basic-month-table.vue_vue_type_script_lang.mjs';
export { default } from './basic-month-table.vue_vue_type_script_lang.mjs';
import { render } from './basic-month-table.vue_vue_type_template_id_2f6fcbf2_lang.mjs';

script.render = render;
script.__file = "packages/components/date-picker/src/date-picker-com/basic-month-table.vue";
//# sourceMappingURL=basic-month-table.mjs.map
